let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iwCRW")).then(() => parcelRequire('4ahfY'));